/*
 * Collection description popover — interaction handlers
 * (TFT customization, 2026-05-13 v2)
 * -----------------------------------------------------
 * Desktop hover and keyboard focus are handled entirely by CSS via
 * .collection-desc-wrapper:hover and :focus-within selectors. This
 * script only handles:
 *   - click/tap toggle (touch-friendly)
 *   - click-outside-to-close
 *   - Escape-to-close + return focus to trigger
 *   - keep only one popover open at a time
 */
(function () {
  'use strict';

  function allTriggers() {
    return document.querySelectorAll('.collection-desc-trigger');
  }

  function closeAll(except) {
    allTriggers().forEach(function (t) {
      if (t !== except) {
        t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.collection-desc-trigger');
    if (trigger) {
      evt.preventDefault();
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      closeAll(trigger);
      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      return;
    }
    // Click outside any popover wrapper closes everything.
    if (!evt.target.closest || !evt.target.closest('.collection-desc-wrapper')) {
      closeAll(null);
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    allTriggers().forEach(function (t) {
      if (t.getAttribute('aria-expanded') === 'true') {
        t.setAttribute('aria-expanded', 'false');
        try { t.focus(); } catch (e) { /* noop */ }
      }
    });
  });
})();
